import { render, staticRenderFns } from "./newfollow.vue?vue&type=template&id=3badadf4&scoped=true&"
import script from "./newfollow.vue?vue&type=script&lang=js&"
export * from "./newfollow.vue?vue&type=script&lang=js&"
import style0 from "./newfollow.vue?vue&type=style&index=0&id=3badadf4&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badadf4",
  null
  
)

export default component.exports